<template>
    <figure class="flex grow flex-col gap-11 lg:w-full">
        <figure class="ml-auto mr-auto flex w-full max-w-xl gap-3">
            <div>
                <v-icon icon="brand-awareness" size="8"></v-icon>
            </div>
            <div class="flex flex-col justify-center">
                <div class="mb-3 text-heading-3-desktop text-black-78">
                    Nastavitve obveščanja
                </div>
                <div class="text-body-regular text-black-40">
                    Tukaj lahko izberete katera obvestila želite prejemati.
                    Lahko se prijavite in odjavite od prejemanja sporočil po
                    elektronski pošti.
                </div>
            </div>
        </figure>
        <form
            method="POST"
            :action="'pošlji'"
            id="profile-settings"
            class="mx-auto mb-0 w-full max-w-xl"
        >
            <v-csrf-token></v-csrf-token>
            <figure class="flex max-w-lg flex-col gap-11 lg:w-full">
                <ul class="grid grid-cols-4 flex-col gap-x-5 gap-y-4">
                    <li class="col-span-4">
                        <v-checkbox
                            :id="'send_search_criteria_emails'"
                            :name="'send_search_criteria_emails'"
                            :label="'Samodejne ponudbe iz shranjenih iskanj'"
                            checkbox-position="right"
                            :value="'true'"
                            :icon="'heart'"
                            :checked="sendSearchCriteriaEmails"
                            @vchanged="
                                (sendSearchCriteriaEmails =
                                    !sendSearchCriteriaEmails),
                                    changeNotificationSettings()
                            "
                            :description="'S to izbiro boste na vašo elektronsko pošto prejemali obvestila o novih oglasih, ki ustrezajovašim shranjenim iskanjem.'"
                            :classLabel="'max-lg:text-heading-4-medium'"
                            :classIcon="'max-lg:min-w-6 max-lg:min-h-6'"
                        ></v-checkbox>
                    </li>
                    <li class="col-span-4">
                        <v-checkbox
                            :id="'newsletter'"
                            :name="'newsletter'"
                            :label="'Elektronske novice'"
                            checkbox-position="right"
                            :value="'true'"
                            :icon="'newsletter'"
                            :checked="newsletter"
                            @vchanged="
                                (newsletter = !newsletter),
                                    changeNotificationSettings()
                            "
                            :description="'S to izbiro boste na vašo elektronsko pošto prejemali novice in promocijske informacije o N24.'"
                            :classLabel="'max-lg:text-heading-4-medium'"
                            :classIcon="'max-lg:min-w-6 max-lg:min-h-6'"
                        ></v-checkbox>
                    </li>
                </ul>
            </figure>
            <hr class="mb-6 mt-6 w-full max-w-xl lg:mb-11 lg:mt-11" />
            <figure class="flex flex-col gap-9">
                <figure class="ml-auto mr-auto flex w-full max-w-xl gap-3">
                    <div>
                        <v-icon icon="password" size="8"></v-icon>
                    </div>
                    <div class="flex flex-col justify-center">
                        <div class="mb-3 text-heading-3-desktop">
                            Ponastavite svoje geslo
                        </div>
                        <div class="text-body-regular text-black-40">
                            Če ste pozabili geslo ali bi ga radi spremenili
                            lahko to storite tu.
                        </div>
                    </div>
                </figure>
                <div class="flex w-full justify-center">
                    <v-lightbox
                        is-authenticated
                        footerless
                        :show="showPasswordModal"
                        @close="showPasswordModal = false"
                    >
                        <template v-slot:trigger>
                            <a
                                class="button button--form"
                                @click="showPasswordModal = true"
                            >
                                <v-icon icon="replay" size="4"></v-icon>
                                Ponastavite geslo
                            </a>
                        </template>
                        <template v-slot:head>
                            <div class="flex items-center">
                                <v-icon
                                    icon="replay"
                                    class="mr-2.5"
                                    size="4"
                                ></v-icon>
                                <div>Ponastavitev gesla</div>
                            </div>
                        </template>
                        <template v-slot:content>
                            <template v-if="!updatePasswordRequestStatus">
                                <form
                                    method="POST"
                                    :action="''"
                                    id="update-password-form"
                                >
                                    <v-csrf-token></v-csrf-token>
                                    <figure
                                        class="flex max-w-lg flex-col gap-11 lg:w-full"
                                    >
                                        <figure class="flex gap-3">
                                            <div>
                                                <v-icon
                                                    icon="password"
                                                    size="8"
                                                ></v-icon>
                                            </div>
                                            <div
                                                class="flex flex-col justify-center"
                                            >
                                                <div
                                                    class="mb-3 text-heading-3-desktop"
                                                >
                                                    Ponastavite svoje geslo
                                                </div>
                                                <div
                                                    class="text-body-regular text-black-40"
                                                >
                                                    Najprej vpišite vaše
                                                    trenutno geslo, nato pa
                                                    izberite novo geslo in novo
                                                    geslo potrdite.
                                                </div>
                                            </div>
                                        </figure>
                                        <figure
                                            class="flex flex-col gap-4 lg:gap-8"
                                        >
                                            <div>
                                                <v-form-input
                                                    id="current_password"
                                                    label="Trenutno geslo"
                                                    type="password"
                                                    name="current_password"
                                                    v-model="currentPassword"
                                                    :error-message="
                                                        currentPasswordError
                                                    "
                                                ></v-form-input>
                                            </div>
                                            <div>
                                                <v-form-input
                                                    id="password"
                                                    label="Novo geslo"
                                                    type="password"
                                                    name="password"
                                                    v-model="password"
                                                    :error-message="
                                                        this.$globalFunctions.parseApiErrors(
                                                            validationErrors,
                                                            'password'
                                                        )
                                                    "
                                                ></v-form-input>
                                            </div>
                                            <div>
                                                <v-form-input
                                                    id="password_confirmation"
                                                    label="Ponovno geslo"
                                                    type="password"
                                                    name="password_confirmation"
                                                    v-model="
                                                        passwordConfirmation
                                                    "
                                                    :error-message="
                                                        this.$globalFunctions.parseApiErrors(
                                                            validationErrors,
                                                            'password_confirmation'
                                                        )
                                                    "
                                                ></v-form-input>
                                            </div>
                                        </figure>
                                    </figure>
                                </form>
                                <!-- <hr
                                    class="mb-6 mt-6 w-full max-w-xl lg:mb-11 lg:mt-11"
                                /> -->
                                <div class="flex w-full justify-center">
                                    <a
                                        class="button button--form"
                                        @click="
                                            submitUpdatePasswordRequest($event)
                                        "
                                    >
                                        <v-icon icon="replay"></v-icon>
                                        Ponastavite geslo
                                    </a>
                                </div>
                            </template>
                            <template v-else>
                                <figure
                                    class="mx-auto my-11 flex max-w-md items-center justify-center gap-2 md:my-32"
                                >
                                    <div class="text-green">
                                        <v-icon icon="check-circle"></v-icon>
                                    </div>
                                    <div
                                        class="text-icon-text-medium text-green"
                                    >
                                        Uspešno ste ponastavili geslo
                                    </div>
                                </figure>
                                <hr
                                    class="mb-6 mt-6 w-full max-w-xl lg:mb-11 lg:mt-11"
                                />
                                <div class="flex w-full justify-center">
                                    <a
                                        class="button button--form"
                                        @click="showPasswordModal = false"
                                    >
                                        <v-icon icon="replay"></v-icon>
                                        Zapri
                                    </a>
                                </div>
                            </template>
                        </template>
                    </v-lightbox>
                </div>
            </figure>
        </form>
    </figure>
</template>

<script>
export default {
    props: {
        user: {
            type: Object,
            required: true,
        },
        editPasswordRoute: {
            type: String,
            required: true,
        },
        editNotificationsRoute: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            sendSearchCriteriaEmails: this.user.send_search_criteria_emails,
            newsletter: this.user.newsletter,
            updatePasswordRequestStatus: false,
            currentPassword: null,
            password: null,
            passwordConfirmation: null,
            validationErrors: {},
            apiError: false,
            showPasswordModal: false,
        };
    },
    methods: {
        changeNotificationSettings() {
            let data = {
                send_search_criteria_emails: this.sendSearchCriteriaEmails,
                newsletter: this.newsletter,
            };

            let config = {
                headers: {
                    "X-CSRF-TOKEN": this.$csrfToken,
                },
            };

            axios.post(this.editNotificationsRoute, data, config).then(
                (response) => {},
                (error) => {
                    console.log(error);
                }
            );
        },
        submitUpdatePasswordRequest(e) {
            e.preventDefault();

            let data = {
                current_password: this.currentPassword,
                password: this.password,
                password_confirmation: this.passwordConfirmation,
            };

            let config = {
                headers: {
                    "X-CSRF-TOKEN": this.$csrfToken,
                },
            };

            axios.post(this.editPasswordRoute, data, config).then(
                (response) => {
                    this.updatePasswordRequestStatus = true;
                    this.apiError = true;
                    this.validationErrors = {};
                },
                (error) => {
                    if (error.response.status == 400) {
                        this.apiError = true;
                        this.validationErrors = {};
                    } else {
                        this.apiError = false;
                        this.validationErrors = error.response.data.errors;
                    }
                    console.log(error);
                }
            );
        },
    },
    computed: {
        currentPasswordError() {
            if (
                this.$globalFunctions.parseApiErrors(
                    this.validationErrors,
                    "current_password"
                )
            ) {
                return this.$globalFunctions.parseApiErrors(
                    this.validationErrors,
                    "current_password"
                );
            }

            if (this.apiError) {
                return "Vnešeno geslo se ujema z trenutnim";
            }

            return "";
        },
    },
};
</script>
